var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmc2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#00CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.44038 10.7781H6.91369L5.84887 12.9375H3.375L4.44038 10.7781ZM5.84944 7.92056H8.32331L7.26187 10.0744H4.78688L5.85 7.92L5.84944 7.92056ZM7.25906 5.06306H9.73294L8.67037 7.21744H6.19706L7.25906 5.0625V5.06306Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90581 10.7775H9.37969L8.31431 12.9364H5.84044L6.90581 10.7775ZM8.31544 7.92H10.7888L9.72675 10.0733H7.25288L8.31544 7.92ZM9.7245 5.0625H12.1984L11.1358 7.21631H8.6625L9.7245 5.0625Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33188 10.7775H11.8058L10.7409 12.9364H8.26706L9.33244 10.7769L9.33188 10.7775ZM10.7415 7.92H13.2154L12.1534 10.0733H9.6795L10.7415 7.92ZM12.1511 5.0625H14.625L13.5624 7.21631H11.0891L12.1511 5.0625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmc2);
export default __webpack_public_path__ + "static/media/emc2.2e380f388aadcf4906dbca6abe68ebec.svg";
export { ForwardRef as ReactComponent };